export const USER_ERROR = 'USER_ERROR';
export const USER_REQUEST = 'USER_REQUEST';
export const USER_RESET = 'USER_RESET';
export const USER_SET = 'USER_SET';
export const USER_SET_REVENUE = 'USER_SET_REVENUE';
export const USER_SUCCESS = 'USER_SUCCESS';
export const USER_UPDATED = 'USER_UPDATED';
export const USER_ONBOARDING_UPDATE = 'USER_ONBOARDING_UPDATE';
